/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';

const RenderRadioGroupWrapper = props => {
  const {
    input,
    label,
    required,
    fullWidth,
    meta: { touched, error },
    t,
    defaultValue,
    values,
  } = props;

  useEffect(() => {
    input.value = defaultValue;
  }, [defaultValue, input, input.value]);

  const handleChange = event => {
    input.onChange(event.target.value);
  };

  return (
    <div>
      <FormControl component="fieldset" fullWidth={fullWidth} style={{ marginTop: '15px', marginBottom: '25px' }}>
        <FormLabel component="legend" style={{ marginBottom: '5px' }}>
          {label} {required && '*'}
        </FormLabel>
        <RadioGroup {...input} defaultValue={defaultValue} aria-label={label} onChange={event => handleChange(event)}>
          {values.map(radiobutton => (
            <FormControlLabel
              value={radiobutton.value}
              control={<Radio />}
              label={radiobutton.label}
              key={radiobutton.value}
            />
          ))}
        </RadioGroup>
        {touched && error && (
          <Typography variant="body1" style={{ fontSize: 16, color: '#FE2213', textAlign: 'left' }}>
            {t(`validation.${error}`)}
          </Typography>
        )}
      </FormControl>
    </div>
  );
};

/* From Navigation
const mapStateToProps = state => ({
  logoImage: R.path(['contentful', 'layout', 'logo', 'fields', 'file', 'url'], state),
});

const mapDispatchToProps = dispatch => ({
  saveLocale: locale => dispatch(saveLocale(locale)),
});
*/

export default RenderRadioGroupWrapper;
